import { ReactNode } from 'react'
import { Tree, TreeDataNode, PopoverProps } from 'antd'

import styled from 'styled-components'

export const StyledTree = styled(Tree)`
  .ant-tree-switcher {
    display: none;
  }
`

export type UseTreeFilterAndOrderBaseArgs<T extends string> = {
  init: {
    checked: T[]
    order: T[]
  }
  disableColumnDragging?: T[]
  columns: Record<T, TreeDataNode>
  popover?: Omit<PopoverProps, 'title' | 'content'>
  hideColumns?: (T | '__actions')[]
  hideTreeColumns?: (T | '__actions')[]
}
export type UseTreeFilterAndOrderReturn<T> = {
  state: T[]
  jsx: {
    toggler: ReactNode
  }
}
